import Swiper from "swiper";
import "swiper/swiper-bundle.css";

// Импорт Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

document.addEventListener("DOMContentLoaded", () => {
  const tabContainer = document.querySelector(".newexamples__tabs");
  if (!tabContainer) return;

  const tabButtons = tabContainer.querySelectorAll(
    ".newexamples__tabs__nav__button"
  );
  const tabContents = tabContainer.querySelectorAll(
    ".newexamples__tabs__content__panel"
  );
  const globalNext = tabContainer.querySelector(
    ".newexamples__tabs__swiper__control--next"
  );
  const globalPrev = tabContainer.querySelector(
    ".newexamples__tabs__swiper__control--prev"
  );
  const swiperControl = tabContainer.querySelector(
    ".newexamples__tabs__swiper__control"
  );

  if (
    !tabButtons.length ||
    !tabContents.length ||
    !globalNext ||
    !globalPrev ||
    !swiperControl
  )
    return;

  let activeSwiper = null;
  let photoSwiper = null;
  let videoSwiper = null;

  // Функция определения breakpoint
  function getCurrentBreakpoint() {
    if (window.innerWidth >= 1024) return "desktop";
    if (window.innerWidth >= 768) return "tablet";
    return "mobile";
  }

  // Определяем, нужно ли показывать кнопки и использовать loop
  function getSwiperConfig(slideCount) {
    const bp = getCurrentBreakpoint();

    if (slideCount === 1) {
      return { showNavigation: false, loop: false };
    } else if (slideCount === 2) {
      return {
        showNavigation: bp === "mobile" || bp === "tablet",
        loop: bp === "mobile",
      };
    } else if (slideCount === 3) {
      return {
        showNavigation: bp !== "desktop",
        loop: bp === "mobile" || bp === "tablet",
      };
    } else {
      // slideCount >= 4
      return { showNavigation: true, loop: true };
    }
  }

  // Инициализация или перенастройка Swiper
  function initSwiper(selector) {
    const container = tabContainer.querySelector(selector);
    if (!container) return null;

    const slides = container.querySelectorAll(".swiper-slide");
    const slideCount = slides.length;

    const config = getSwiperConfig(slideCount);

    // Применяем конфигурацию
    const params = {
      loop: config.loop,
      roundLengths: true, // ← КЛЮЧЕВОЕ
      observer: true,
      observeSlideChildren: true,
      observeParents: true,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
          loop: config.loop && slideCount >= 4,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
          loop: config.loop,
        },
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: config.loop,
        },
      },
      on: {
        init: () => updateNavigationVisibility(config.showNavigation),
        resize: () => {
          const newConfig = getSwiperConfig(slideCount);
          updateNavigationVisibility(newConfig.showNavigation);
        },
      },
    };

    // Убираем loop, если не нужен
    if (!config.loop) {
      params.loop = false;
      delete params.breakpoints[1024].loop;
      delete params.breakpoints[768].loop;
      delete params.breakpoints[0].loop;
    }

    // Если уже был Swiper — уничтожаем
    if (container.swiperInstance) {
      container.swiperInstance.destroy(true, true);
    }

    const swiper = new Swiper(container, params);
    container.swiperInstance = swiper;

    // Перезапускаем Fancybox после инициализации/обновления слайдера
    if (selector === ".photo-slider" || selector === ".video-slider") {
      initFancybox();
    }

    // Сохраняем и делаем активным
    updateNavigationVisibility(config.showNavigation);
    return swiper;
  }

  // Управление видимостью глобальных кнопок
  function updateNavigationVisibility(show) {
    if (show) {
      swiperControl.classList.remove("is-hidden");
    } else {
      swiperControl.classList.add("is-hidden");
    }
  }

  // Переключение табов
  function handleTabClick(e) {
    const button = e.target.closest(".newexamples__tabs__nav__button");
    if (!button || !button.dataset.tab) return;

    const targetTab = button.dataset.tab;

    tabButtons.forEach((btn) => btn.classList.remove("is-active"));
    tabContents.forEach((panel) => panel.classList.remove("is-active"));

    button.classList.add("is-active");
    const targetPanel = tabContainer.querySelector(
      `[data-tab-content="${targetTab}"]`
    );
    if (!targetPanel) return;

    targetPanel.classList.add("is-active");

    if (targetTab === "photo") {
      if (!photoSwiper) {
        photoSwiper = initSwiper(".photo-slider");
      } else {
        photoSwiper.update();
        initFancybox(); // перезапускаем Fancybox на случай, если что-то поменялось
      }
      activeSwiper = photoSwiper;
    } else if (targetTab === "video") {
      if (!videoSwiper) {
        videoSwiper = initSwiper(".video-slider");
      } else {
        videoSwiper.update();
        initFancybox();
      }
      activeSwiper = videoSwiper;
    }
  }

  // Привязка кликов по табам
  tabButtons.forEach((button) =>
    button.addEventListener("click", handleTabClick)
  );

  // Инициализация при загрузке
  const initialTabButton = tabContainer.querySelector(
    ".newexamples__tabs__nav__button.is-active"
  );
  if (initialTabButton) {
    const initialTab = initialTabButton.dataset.tab;
    if (initialTab === "photo") {
      photoSwiper = initSwiper(".photo-slider");
      activeSwiper = photoSwiper;
    } else if (initialTab === "video") {
      videoSwiper = initSwiper(".video-slider");
      activeSwiper = videoSwiper;
    }
  }

  // Глобальные кнопки управления
  [globalNext, globalPrev].forEach((button) => {
    button.addEventListener("click", () => {
      if (!activeSwiper) return;
      button.classList.contains("newexamples__tabs__swiper__control--next")
        ? activeSwiper.slideNext()
        : activeSwiper.slidePrev();
    });
  });

  // Инициализация Fancybox — только для оригинальных слайдов (без дубликатов)
  function initFancybox() {
    // Сначала отключаем все предыдущие бинды внутри tabContainer
    Fancybox.unbind(tabContainer);

    // Биндим только оригинальные слайды (без класса swiper-slide-duplicate)
    Fancybox.bind(
      tabContainer,
      ".swiper-slide:not(.swiper-slide-duplicate) a[data-fancybox]",
      {
        Toolbar: true,
        closeButton: true,
        dragToClose: true,
        animated: true,
        infinite: false,

        // Поддержка видео (если используется)
        Video: {
          autoStart: false,
        },
      }
    );
  }

  // Очистка при выгрузке
  window.addEventListener("beforeunload", () => {
    Fancybox.unbind(tabContainer);
    Fancybox.close();
  });

  // Реагирование на ресайз окна
  window.addEventListener("resize", () => {
    if (activeSwiper && activeSwiper.params) {
      const slides = activeSwiper.el.querySelectorAll(".swiper-slide").length;
      const config = getSwiperConfig(slides);
      updateNavigationVisibility(config.showNavigation);
    }
  });
});
